import { colors } from "./colors/gelishColors";
export const promos = [
    {
        // Publish date for April 1, 2025 -- Ends April 31, 2025
        publish_date: [2025, 2, 30],
        end_date: [2025, 4, 1],
        skus: ["1121764", "1121798", "1720004"],
        name: "Up to 40% OFF",
        link: "#",
        image: {
            img: "/images/sale/april-2025/40_off_kits.webp",
            img2x: "/images/sale/april-2025/40_off_kits@2x.webp",
            img3x: "/images/sale/april-2025/40_off_kits@2x.webp"
        },
        menu: {
            img: "/images/sale/april-2025/40_off_kits_menu.webp",
            img2x: "/images/sale/april-2025/40_off_kits_menu@2x.webp",
            img3x: "/images/sale/april-2025/40_off_kits_menu@2x.webp"
        },
        isOnlyMenu: false,
    },
    {
        // Publish date for April 1, 2025 -- Ends April 31, 2025
        publish_date: [2025, 3, 18],
        end_date: [2025, 4, 1],
        skus: ["1168226", "1168241"],
        name: "25% OFF IN SELECT ELECTRONICS",
        link: "/nail-lamps-tools/e-files",
        image: {
            img: "/images/sale/april-2025/25_off_file.webp",
            img2x: "/images/sale/april-2025/25_off_file@2x.webp",
            img3x: "/images/sale/april-2025/25_off_file@2x.webp"
        },
        menu: {
            img: "/images/sale/april-2025/25_off_file_menu.webp",
            img2x: "/images/sale/april-2025/25_off_file_menu@2x.webp",
            img3x: "/images/sale/april-2025/25_off_file_menu@2x.webp"
        },
        isOnlyMenu: false,
    },
    {
        // Publish date for April 1, 2025 -- Ends April 31, 2025
        publish_date: [2025, 3, 18],
        end_date: [2025, 4, 1],
        skus: ["1248", "1249", "1229", "1250", "1251", "1228", "3610800", "3610801", "3610802", "3610803", "3610900", "3610901", "3610902", "3610903", "3611600", "3611801", "3611802", "3611803", "3611804", "3611805", "3611806", "3611807",],
        name: "40% OFF",
        link: "/nail-care/bare-luxury",
        image: {
            img: "/images/sale/april-2025/40_off_bareluxury.webp",
            img2x: "/images/sale/april-2025/40_off_bareluxury@2x.webp",
            img3x: "/images/sale/april-2025/40_off_bareluxury@3x.webp"
        },
        menu: {
            img: "/images/sale/april-2025/40_off_bareluxury_menu.webp",
            img2x: "/images/sale/april-2025/40_off_bareluxury_menu@2x.webp",
            img3x: "/images/sale/april-2025/40_off_bareluxury_menu@2x.webp"
        },
        isOnlyMenu: false,
    },
]